var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseOWeb = function SvgCloseOWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.336 8.322a1 1 0 1 0-1.364-1.463l-2.926 2.728L9.319 6.66a1 1 0 0 0-1.464 1.364l2.728 2.926-2.926 2.728A1 1 0 1 0 9.02 15.14l2.926-2.727 2.728 2.926a1 1 0 0 0 1.463-1.363l-2.728-2.926z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "M.996 11c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11-11-4.925-11-11m11 9a9 9 0 1 1 0-18 9 9 0 0 1 0 18",
    clipRule: "evenodd"
  })));
};
export default SvgCloseOWeb;